import axios from "axios";
import router from '../../router/index';

export const state = {
    save_status: false,
    production_cart: {},
    production_batches:{},
    batch_details:{},
    production_factories:{},
    filter_status:false,
    input_item: '',
    factory_performance: {},
    produced_products:[],
    output_products:[],
};

export const getters = {
    ProductionCart: state => state.production_cart.data,
    ProductionBatches: state => state.production_batches.data,
    BatchDetails: state => state.batch_details.data,
    ProductionFactories: state => state.production_factories,
    SaveStatus: state => state.save_status,
    filterStatus: state => state.filter_status,
    factoryPerformance: state => state.factory_performance,
    ProducedProducts: state => state.produced_products.data,
    OutputProducts: state => state.output_products,
};

export const mutations = {
    set_save_status(state, newValue) {
        state.save_status = newValue;
    },

    set_production_cart(state, newValue) {
        state.production_cart = newValue;
    },

    set_production_batches(state, newValue) {
        state.production_batches = newValue;
    },

    set_filter_status(state, newValue) {
        state.filter_status = newValue;
    },

    set_batch_details(state, newValue) {
        state.batch_details = newValue;
    },

    set_production_factories(state, newValue) {
        state.production_factories = newValue;
    },

    set_input_item(state, newValue) {
        state.input_item = newValue;
    },

    set_factory_performance(state, newValue) {
        state.factory_performance = newValue;
    },
    SET_PRODUCED_PRODUCTS(state, newValue) {
        state.produced_products = newValue
    },
    SET_OUTPUT_PRODUCTS(state, newValue) {
        state.output_products = newValue
    },
};

export const actions = {
    // Fetch production cart items
    async fetchProductionCart({ commit, dispatch }) {
        commit('set_save_status', true)

        try {
            const response = await axios.get('production_cart');
            commit('set_production_cart', response.data);
            commit('set_save_status', false)

        } catch (error) {
            commit('set_save_status', false)
            let message = { 'msg': "Error Rcording Consumable Item usage " + error }
            dispatch('notification/error', message, { root: true })
        }
    },

    // Add item to production cart
    addToProductionCart({ commit, dispatch }, payload) {
        commit('set_save_status', true);
        axios.post('production_cart', payload)
            .then(() => {
                dispatch('fetchProductionCart');
                const message = { 'msg': 'Production item added to cart successfully' };
                dispatch('notification/success', message, { root: true });
                commit('set_save_status', false);
            })
            .catch(error => {
                commit('set_save_status', false);
                const message = { 'msg': `Error adding production item to cart: ${error}` };
                dispatch('notification/error', message, { root: true });
            });
    },

    // Edit item in production cart
    editProductionCart({ commit, dispatch }, payload) {
        commit('set_save_status', true);
        axios.put(`production_cart/${payload.id}`, payload)
            .then(() => {
                dispatch('fetchProductionCart');
                const message = { 'msg': `Production item ${payload.name} updated successfully in cart` };
                dispatch('notification/success', message, { root: true });
                commit('set_save_status', false);
            })
            .catch(error => {
                commit('set_save_status', false);
                const message = { 'msg': `Error updating production item in cart: ${error}` };
                dispatch('notification/error', message, { root: true });
            });
    },

    // Delete item from production cart
    deleteProductionCart({ commit, dispatch }, payload) {
        commit('set_save_status', true);
        axios.delete(`production_cart/${payload.id}`)
            .then(() => {
                dispatch('fetchProductionCart');
                const message = { 'msg': `Production item ${payload.name} deleted from cart successfully` };
                dispatch('notification/success', message, { root: true });
                commit('set_save_status', false);
            })
            .catch(error => {
                commit('set_save_status', false);
                const message = { 'msg': `Error deleting production item from cart: ${error}` };
                dispatch('notification/error', message, { root: true });
            });
    },
    
    saveProduction({ commit, dispatch }, payload) {
        commit('set_save_status', true);
        axios.post('production', payload)
            .then((response) => {
                if(response.status == 200){
                    const message = { 'msg': 'Production Batch Saved successfully' };
                    dispatch('notification/success', message, { root: true });
                }else{
                    const message = { 'msg': response.data.message };
                    dispatch('notification/error', message, { root: true });
                }
                dispatch('fetchProductionCart');                
                commit('set_save_status', false);
            })
            .catch(error => {
                commit('set_save_status', false);
                const message = { 'msg': `Error Saving production Batch : ${error}` };
                dispatch('notification/error', message, { root: true });
            });
    },

    // Fetch Production Batches
    fetchProductionBatches({ commit }, payload) {
        commit('set_filter_status', true);
        axios.post(`production_batches`, payload).then(ec_res => {
            commit('set_filter_status', false);
            commit('set_production_batches', ec_res.data)
        })
    },

    fetchBatchDetails({ commit }, id) {
        commit('set_filter_status', true);
        axios.get(`production_batchdetails/${id}`).then(ec_res => {
        commit('set_filter_status', false);
        commit('set_batch_details', ec_res.data)
        })
    },

    // Edit batch
    editBatch({ commit, dispatch }, payload) {
        commit('set_save_status', true);
        axios.put(`edit_production_batches/${payload.id}`).then((response) => {
            if(response.status == 200) {
                commit('set_save_status', false);
                router.push('/production/cart').catch(() => {});
            }else{
                commit('set_save_status', false);
                let message = { 'msg': response.data.message }
                dispatch('notification/error', message, { root: true })
            }            
        }).catch(() => {
            commit('set_save_status', false)
            let message = { 'msg': "Error Editing Product Batch" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Delete batch
    deleteBatch({ commit, dispatch }, payload) {
        commit('set_save_status', true);
        axios.delete(`delete_production_batches/${payload.id}`).then((response) => {
            if(response.status == 200) {
                dispatch('fetchProductionBatches',payload.data);
                const message = { 'msg': `Production batch deleted successfully` };
                dispatch('notification/success', message, { root: true });
                commit('set_save_status', false);                
            }else{
                commit('set_save_status', false);
                let message = { 'msg': response.data.message }
                dispatch('notification/error', message, { root: true })
            }   
        }).catch(() => {
            commit('set_save_status', false)
            let message = { 'msg': "Error Deleting Production Batch" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Fetch Production Factories
    fetchProductionFactories({ commit }) {
        axios.get(`fetch_productionfactories`).then(ec_res => {
        commit('set_production_factories', ec_res.data)
        })
    },

    // add Production Factory
    addProductionFactory({ commit, dispatch }, payload) {
        commit('set_save_status', true);
        axios.post('add_productionfactory', payload).then((response) => {
            if(response.status == 200) {
                dispatch('fetchProductionFactories');
                const message = { 'msg': `Production factory added successfully` };
                dispatch('notification/success', message, { root: true });
                commit('set_save_status', false);                
            }else{
                commit('set_save_status', false);
                let message = { 'msg': response.data.message }
                dispatch('notification/error', message, { root: true })
            }             
        }).catch(() => {
            commit('set_save_status', false)
            let message = { 'msg': "Error Adding Production factory" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // edit Production Factory
    editProductionFactory({ commit, dispatch }, payload) {
        commit('set_save_status', true);
        axios.put(`edit_productionfactory/${payload.id}`, payload).then((response) => {
            if(response.status == 200) {
                dispatch('fetchProductionFactories');
                const message = { 'msg': `Production factory edited successfully` };
                dispatch('notification/success', message, { root: true });
                commit('set_save_status', false);                
            }else{
                commit('set_save_status', false);
                let message = { 'msg': response.data.message }
                dispatch('notification/error', message, { root: true })
            }             
        }).catch(() => {
            commit('set_save_status', false)
            let message = { 'msg': "Error Editing Production factory" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // delete Production Factory
    deleteProductionFactory({ commit, dispatch }, payload) {
        commit('set_save_status', true);
        axios.delete(`delete_productionfactory/${payload.id}`, payload).then((response) => {
            if(response.status == 200) {
                dispatch('fetchProductionFactories');
                const message = { 'msg': `Production factory deleted successfully` };
                dispatch('notification/success', message, { root: true });
                commit('set_save_status', false);                
            }else{
                commit('set_save_status', false);
                let message = { 'msg': response.data.message }
                dispatch('notification/error', message, { root: true })
            }             
        }).catch(() => {
            commit('set_save_status', false)
            let message = { 'msg': "Error Deleting Production factory" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // received amount
    receivedAmount({ commit, dispatch }, payload) {
        commit('set_save_status', true);
        axios.put(`receive_amount/${payload.id}`, payload).then((response) => {
            if(response.status == 200) {
                dispatch('fetchProductionBatches', payload.filterdata);
                const message = { 'msg': `Amount received recorded successfully` };
                dispatch('notification/success', message, { root: true });
                commit('set_save_status', false);                
            }else{
                commit('set_save_status', false);
                let message = { 'msg': response.data.message }
                dispatch('notification/error', message, { root: true })
            }             
        }).catch(() => {
            commit('set_save_status', false)
            let message = { 'msg': "Error recording amount received" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Fetch Input Item
    getInputItem({ commit }) {
        axios.get(`input_item`).then(res => {
        commit('set_input_item', res)
        })
    },

    // Fetch Factory Performance
    fetchFactoryPerformance({ commit }, payload) {
        commit('set_filter_status', true)        
        axios.post('factory_performance', payload).then(response => {
            commit('set_filter_status', false)  
            commit('set_factory_performance', response.data)
        })
    },

    fetchProducedProducts({ commit }) {
        axios.get('produced_products').then(response => {
            commit('SET_PRODUCED_PRODUCTS', response.data)
        })
    },

    //Product Price Categories
    fetchOutputProducts({ commit }) {
        axios.get(`output_products`).then(ec_res => {
            commit('SET_OUTPUT_PRODUCTS', ec_res.data)
        })
    },

    addOutputProduct({ commit, dispatch }, payload) {
        commit('set_save_status', true);
        axios.post('output_products', payload).then((response) => {
            if(response.status == 200){
                dispatch('fetchOutputProducts');
                let message = { 'msg': `Output Product ${payload.name} added successfully` }
                dispatch('notification/success', message, { root: true })
            }else if(response.status == 202){
                dispatch('fetchOutputProducts');
                let message = { 'msg': response.data.message }
                dispatch('notification/error', message, { root: true })
            }else{
                commit('set_save_status', false)
                let message = { 'msg': "Error Adding Output Product" }
                dispatch('notification/error', message, { root: true })
            }            
            commit('set_save_status', false);
        }).catch((error) => {
            commit('set_save_status', false)
            let message = { 'msg': "Error Adding Output Product " + error }
            dispatch('notification/error', message, { root: true })
        })
    },

    editOutputProduct({ commit, dispatch }, payload) {
        commit('set_save_status', true);
        axios.put(`output_products/${payload.id}`, payload).then(() => {
            dispatch('fetchOutputProducts');
            let message = { 'msg': `Output Product ${payload.name} updated successfully` }
            dispatch('notification/success', message, { root: true })
            commit('set_save_status', false);
        }).catch(() => {
            commit('set_save_status', false)
            let message = { 'msg': "Error Updating Output Product" }
            dispatch('notification/error', message, { root: true })
        })
    },

    deleteOutputProduct({ commit, dispatch }, payload) {
        commit('set_save_status', true);
        axios.delete(`output_products/${payload.id}`).then(() => {
            dispatch('fetchOutputProducts');
            let message = { 'msg': `Output Product ${payload.name} deleted successfully` }
            dispatch('notification/success', message, { root: true })
            commit('set_save_status', false);
        }).catch((error) => {
            commit('set_save_status', false)
            let message = { 'msg': "Error in deleting Output Product" + error }
            dispatch('notification/error', message, { root: true })
        })
    },
};